import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import ProtectedRoute from "./context/ProtectedRoute.jsx";
import ListofProducts from "./Functionality/ListofProducts";
import LoginPage from "./Functionality/LoginPage";
import Forgotpwd from "./Functionality/Forgotpwd";
import AutoLogout from "./Components/AutoLogout.jsx";
import Footer from "./Functionality/Footer";
import { useSelector } from "react-redux";
import HomePage from "./Functionality/HomePage";
import ProductionModule from "./Functionality/ProductionModule";
import Transport from "./Functionality/Transport";
import ImportCosting from "./Functionality/ImportCosting";
import ItemMaster from "./Functionality/ItemMaster";
import ItemMasterReport from "./Functionality/Reports/ItemMasterReport";
import ImportCostingReport from "./Functionality/Reports/ImportCostingReport";
import ProductionModuleRawMaterialReport from "./Functionality/Reports/ProductionModuleRawMaterialReport";
import ProductionModuleDerivedItemsReport from "./Functionality/Reports/ProductionModuleDerivedItemsReport";
import CostingTransportReport from "./Functionality/Reports/CostingTransportReport";
import RouteMaster from "./Functionality/RouteMaster";
import ChargesMaster from "./Functionality/ChargesMaster";
import CostAnalysis from "./Functionality/CostAnalysis";
import SupplierMaster from "./Functionality/SupplierMaster";
import PriceListReport from "./Functionality/Reports/PriceListReport";
import MillMaster from "./Functionality/MillMaster";
import ReportCostAnalysis from "./Functionality/Reports/ReportCostAnalysis.js";

// Logistics
import Dashboard from "./Functionality/Logistics/Dashboard.js";
import ListOfVehiclesPendingGateInwards from "./Functionality/Logistics/ListOfVehiclesPendingGateInwards.js";
import VehiclesPendingInspectionAfterGateIn from "./Functionality/Logistics/VehiclesPendingInspectionAfterGateIn.js";
import VehiclesToComeToReturns from "./Functionality/Logistics/VehiclesToComeToReturns.js";
import VehiclesFromReturnsBackToInspection from "./Functionality/Logistics/VehiclesFromReturnsBackToInspection.js";
import ViewLoadingAdvise from "./Functionality/Logistics/ViewLoadingAdvise.js";
import VehiclesExpectedInWorkshop from "./Functionality/Logistics/VehiclesExpectedInWorkshop.js";
import VehiclesInWorkshopAndJobsOpen from "./Functionality/Logistics/VehiclesInWorkshopAndJobsOpen.js";
import ReleaseVehiclesFromWorkshop from "./Functionality/Logistics/ReleaseVehiclesFromWorkshop.js";
import ListOfTrucksReleasedFromWorkshop from "./Functionality/Logistics/ListOfTrucksReleasedFromWorkshop.js";
import ListOfTrucksReadyForLoading from "./Functionality/Logistics/ListOfTrucksReadyForLoading.js";
import DispatchOfVehicles from "./Functionality/Logistics/DispatchOfVehicles.js";
import GateOutwards from "./Functionality/Logistics/GateOutwards.js";
import MileageIssueRequest from "./Functionality/Logistics/MileageIssueRequest.js";
import FuelAllocationSetupKMBased from "./Functionality/Logistics/FuelAllocationSetupKMBased.js";
import WeighBridge from "./Functionality/Logistics/WeighBridge.js";
import WeighbridgeIn from "./Functionality/Logistics/WeighbridgeIn.js";
import WeighbridgeOut from "./Functionality/Logistics/WeighbridgeOut.js";
import WeighBridgeInToFollow from "./Functionality/Logistics/WeighBridgeInToFollow.js";
import DispatchLocationsMaster from "./Functionality/Logistics/DispatchLocationsMaster.js";
import FUELTOPUPREASONS from "./Functionality/Logistics/FUELTOPUPREASONS.jsx";
import TOPUPFUELVOUCHER from "./Functionality/Logistics/TOPUPFUELVOUCHER.jsx";

import SetUpDashboard from "./Functionality/Logistics/SetUpDashboard.js";
import ComplianceChecklist from "./Functionality/Logistics/ComplianceChecklist.js";
import TaskMaster from "./Functionality/Logistics/TaskMaster.js";
import FuelAndMileageVouchers from "./Functionality/Logistics/STANDARDFUELISSUE.jsx";
import GateMaster from "./Functionality/Logistics/GateMaster.js";
import WeighbridgeMaster from "./Functionality/Logistics/WeighbridgeMaster.js";
import FuelAllocation from "./Functionality/Logistics/FuelAllocation.jsx";
import EmployeeMaster from "./Functionality/Logistics/EmployeeMaster.jsx";
import VehiclesAndTheirCurrentStatus from "./Functionality/Logistics/VehiclesAndTheirCurrentStatus.js";
import ReturnActionsMaster from "./Functionality/Logistics/ReturnActionsMaster.js";
import ReturnReasonMaster from "./Functionality/Logistics/ReturnReasonMaster.js";
import VehiclesKPI from "./Functionality/Logistics/VehiclesKPI.js";
import ErrorCorrections from "./Functionality/Logistics/ErrorCorrections.js";
import MileageAllocationSetupKMBased from "./Functionality/Logistics/MileageAllocationSetupKMBased.jsx";
import MileageForCanters from "./Functionality/Logistics/MileageForCanters.js";
import DriverKPI from "./Functionality/Logistics/DriverKPI.js";

import CityMaster from "./Functionality/Logistics/CityMaster.jsx";
import RouteMasterLog from "./Functionality/Logistics/RouteMaster.jsx";
import Make from "./Functionality/Logistics/Make.jsx";
import Model from "./Functionality/Logistics/Model.jsx";
import MakeAndModel from "./Functionality/Logistics/MakeAndModel.jsx";
import VehicleMaster from "./Functionality/Logistics/VehicleMaster.jsx";

import Reports from "./Functionality/Logistics/Reports.jsx";

import QuickReports from "./Functionality/Reports.jsx";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/Forgotpwd" element={<Forgotpwd />} />
        <Route path="/AutoLogout" element={<AutoLogout />} />
        <Route
          path="/HomePage"
          element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ProductionModule"
          element={
            <ProtectedRoute>
              <ProductionModule />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Transport"
          element={
            <ProtectedRoute>
              <Transport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ImportCosting"
          element={
            <ProtectedRoute>
              <ImportCosting />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ItemMaster"
          element={
            <ProtectedRoute>
              <ItemMaster />
            </ProtectedRoute>
          }
        />
        {/* Reports */}
        <Route
          path="/ItemMasterReport"
          element={
            <ProtectedRoute>
              <ItemMasterReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ImportCostingReport"
          element={
            <ProtectedRoute>
              <ImportCostingReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ProductionModuleRawMaterialReport"
          element={
            <ProtectedRoute>
              <ProductionModuleRawMaterialReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ProductionModuleDerivedItemsReport"
          element={
            <ProtectedRoute>
              <ProductionModuleDerivedItemsReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/CostingTransportReport"
          element={
            <ProtectedRoute>
              <CostingTransportReport />
            </ProtectedRoute>
          }
        />
        {/* <Route
          path="/RouteMaster"
          element={
            <ProtectedRoute>
              <RouteMaster />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path="/ChargesMaster"
          element={
            <ProtectedRoute>
              <ChargesMaster />
            </ProtectedRoute>
          }
        />
        <Route
          path="/MillMaster"
          element={
            <ProtectedRoute>
              <MillMaster />
            </ProtectedRoute>
          }
        />
        <Route
          path="/CostAnalysis"
          element={
            <ProtectedRoute>
              <CostAnalysis />
            </ProtectedRoute>
          }
        />
        <Route
          path="/SupplierMaster"
          element={
            <ProtectedRoute>
              <SupplierMaster />
            </ProtectedRoute>
          }
        />
        <Route
          path="/PriceListReport"
          element={
            <ProtectedRoute>
              <PriceListReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ReportCostAnalysis"
          element={
            <ProtectedRoute>
              <ReportCostAnalysis />
            </ProtectedRoute>
          }
        />
        {/* Logistics */}
        <Route
          path="/Dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Reports"
          element={
            <ProtectedRoute>
              <Reports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/QuickReports"
          element={
            <ProtectedRoute>
              <QuickReports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ListOfVehiclesPendingGateInwards"
          element={
            <ProtectedRoute>
              <ListOfVehiclesPendingGateInwards />
            </ProtectedRoute>
          }
        />
        <Route
          path="/GATEIN"
          element={
            <ProtectedRoute>
              <ListOfVehiclesPendingGateInwards />
            </ProtectedRoute>
          }
        />
        <Route
          path="/VehiclesPendingInspectionAfterGateIn"
          element={
            <ProtectedRoute>
              <VehiclesPendingInspectionAfterGateIn />
            </ProtectedRoute>
          }
        />
        <Route
          path="/VERIFICATIONANDINSPECTIONAFTERGATEIN"
          element={
            <ProtectedRoute>
              <VehiclesPendingInspectionAfterGateIn />
            </ProtectedRoute>
          }
        />
        <Route
          path="/RETURNSFROMCUSTOMER"
          element={
            <ProtectedRoute>
              <VehiclesToComeToReturns />
            </ProtectedRoute>
          }
        />
        <Route
          path="/VehiclesFromReturnsBackToInspection"
          element={
            <ProtectedRoute>
              <VehiclesFromReturnsBackToInspection />
            </ProtectedRoute>
          }
        />
        <Route
          path="/VehiclesExpectedInWorkshop"
          element={
            <ProtectedRoute>
              <VehiclesExpectedInWorkshop />
            </ProtectedRoute>
          }
        />
        <Route
          path="/VehiclesInWorkshopAndJobsOpen"
          element={
            <ProtectedRoute>
              <VehiclesInWorkshopAndJobsOpen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/JOBCARDOPENING"
          element={
            <ProtectedRoute>
              <VehiclesInWorkshopAndJobsOpen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/JOBCARDCLOSING"
          element={
            <ProtectedRoute>
              <VehiclesInWorkshopAndJobsOpen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ReleaseVehiclesFromWorkshop"
          element={
            <ProtectedRoute>
              <ReleaseVehiclesFromWorkshop />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ListOfTrucksReleasedFromWorkshop"
          element={
            <ProtectedRoute>
              <ListOfTrucksReleasedFromWorkshop />
            </ProtectedRoute>
          }
        />
        <Route
          path="/LOADINGORDERS"
          element={
            <ProtectedRoute>
              <ListOfTrucksReadyForLoading />
            </ProtectedRoute>
          }
        />
        <Route
          path="/DISPATCHOFVEHICLES"
          element={
            <ProtectedRoute>
              <DispatchOfVehicles />
            </ProtectedRoute>
          }
        />
        <Route
          path="/GATEOUTWARDS"
          element={
            <ProtectedRoute>
              <GateOutwards />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ViewLoadingAdvise"
          element={
            <ProtectedRoute>
              <ViewLoadingAdvise />
            </ProtectedRoute>
          }
        />
        <Route
          path="/SetUpDashboard"
          element={
            <ProtectedRoute>
              <SetUpDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/COMPLIANCECHECKLIST"
          element={
            <ProtectedRoute>
              <ComplianceChecklist />
            </ProtectedRoute>
          }
        />
        <Route
          path="/TASKMASTER"
          element={
            <ProtectedRoute>
              <TaskMaster />
            </ProtectedRoute>
          }
        />
        <Route
          path="/DISPATCHLOCATIONMASTER"
          element={
            <ProtectedRoute>
              <DispatchLocationsMaster />
            </ProtectedRoute>
          }
        />

        <Route
          path="/FUELTOPUPREASONS"
          element={
            <ProtectedRoute>
              <FUELTOPUPREASONS />
            </ProtectedRoute>
          }
        />
        <Route
          path="/TOPUPFUELVOUCHER"
          element={
            <ProtectedRoute>
              <TOPUPFUELVOUCHER />
            </ProtectedRoute>
          }
        />
        <Route
          path="/CREATEGATES"
          element={
            <ProtectedRoute>
              <GateMaster />
            </ProtectedRoute>
          }
        />
        <Route
          path="/CREATEWEIGHBRIDGES"
          element={
            <ProtectedRoute>
              <WeighbridgeMaster />
            </ProtectedRoute>
          }
        />
        <Route
          path="/MILEAGEISSUANCES"
          element={
            // <ProtectedRoute>
            <MileageIssueRequest />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/FUELALLOCATIONSETUP-KMBASED"
          element={
            // <ProtectedRoute>
            <FuelAllocationSetupKMBased />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/WeighBridge"
          element={
            // <ProtectedRoute>
            <WeighBridge />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/WEIGHBRIDGEIN"
          element={
            // <ProtectedRoute>
            <WeighbridgeIn />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/WEIGHBRIDGEOUT"
          element={
            // <ProtectedRoute>
            <WeighbridgeOut />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/SUCCEEDINGWEIGHBRIDGES"
          element={
            // <ProtectedRoute>
            <WeighBridgeInToFollow />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/FUELVOUCHERPROCESSING"
          element={
            // <ProtectedRoute>
            <FuelAndMileageVouchers />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/FUELVOUCHERPROCESSING-LS"
          element={
            // <ProtectedRoute>
            <FuelAllocation />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/EMPLOYEEMASTER"
          element={
            // <ProtectedRoute>
            <EmployeeMaster />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/VEHICLESANDTHEIRCURRENTSTATUS"
          element={
            // <ProtectedRoute>
            <VehiclesAndTheirCurrentStatus />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/RETURNSACTIONMASTER"
          element={
            // <ProtectedRoute>
            <ReturnActionsMaster />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/RETURNSREASONMASTER"
          element={
            // <ProtectedRoute>
            <ReturnReasonMaster />
            // </ProtectedRoute>
          }
        />
        
        <Route
          path="/VEHICLESKPI"
          element={
            // <ProtectedRoute>
            <VehiclesKPI />
            // </ProtectedRoute>
          }
        />
        
        <Route
          path="/DRIVERSKPI"
          element={
            // <ProtectedRoute>
            <DriverKPI />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/LOGISTICSERRORCORRECTIONS"
          element={
            // <ProtectedRoute>
            <ErrorCorrections />
            // </ProtectedRoute>
          }
        />
        
        <Route
          path="/MILEAGEALLOCATIONSETUP-KMBASED"
          element={
            // <ProtectedRoute>
            <MileageAllocationSetupKMBased />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/MILEAGEFORCANTERS"
          element={
            // <ProtectedRoute>
            <MileageForCanters />
            // </ProtectedRoute>
          }
        />

        <Route
          path="/CITIESANDTOWNSMASTER"
          element={
            <CityMaster />
          }
        />

        <Route
          path="/ROUTEMASTER"
          element={
            <RouteMasterLog />
          }
        />
        <Route
          path="/VEHICLEMAKE"
          element={
            <Make />
          }
        />
        <Route
          path="/VEHICLEMODEL"
          element={
            <Model />
          }
        />
        <Route
          path="/VEHICLEMAKETOMODEL"
          element={
            <MakeAndModel />
          }
        />
         <Route
          path="/VEHICLEMASTER"
          element={
            <VehicleMaster />
          }
        />
      </Routes>
      <div className="block print:hidden">
      <Footer />
      </div>
    </Router>
  );
};
export default App;
